import { makeStyles } from '@material-ui/core/styles';

export const useNavigationDropdownStyles = makeStyles(
  ({ spacing, palette }) => ({
    menuPopover: {
      '& .MuiMenu-paper': {
        background: 'transparent',
      },
    },
    navigationDropdownContent: {
      padding: `${spacing(2, 2)} !important`,
      backgroundColor: palette.primary.dark,
      minWidth: '240px',
      maxWidth: '280px',
    },
  }),
  { name: 'NavigationDropdown' },
);
